import reactCSS from 'reactcss';
import cssSides, { Side } from '@team-griffin/css-sides';
import { headingL, headingM, headingS, content } from '@ux/type-size';
import { gu2px } from '@ux/theme-utils';
import { percentage } from '@ux/style-utils';

export default ({
  theme,
  isMinSm,
  isMinMd,
}) => {
  const {
    spacing,
    palette,
    typography,
  } = theme;

  return reactCSS({
    default: {
      root: {
        color: palette.grey02,
        marginBottom: gu2px(2, spacing),
        overflow: 'hidden',
      },

      body: {
        ...cssSides('padding', Side.A, gu2px(3, spacing)),
        textAlign: 'center',
      },

      text: {
        display: 'block',
        wordWrap: 'break-word',
        fontWeight: 400,
        minWidth: percentage(50),
        ...headingS(typography),
        marginBottom: gu2px(2, spacing),
      },

      options: {
        ...content(typography),
      },

      fqdn: {
        display: 'inline-block',
        wordBreak: 'break-all',
        fontWeight: 600,
      },

      button: {
        display: 'block',
        marginTop: gu2px(2, spacing),
      },

      link: {
        color: palette.primary,
      },

      message: {
        textAlign: 'center',
      },

      negotiate: {
        backgroundColor: palette.primary,
        color: palette.primaryContrast,
        ...content(typography),
        ...cssSides('padding', Side.A, gu2px(3, spacing)),
        textAlign: 'center',
      },

      action: {
        whiteSpace: 'nowrap',
        ...cssSides('margin', Side.X, gu2px(1, spacing) / 2),
        marginTop: gu2px(1, spacing),
      },

      icon: {
        color: palette.green01,
        size: gu2px(3, spacing),
        verticalAlign: 'bottom',
        lineHeight: 1,
        display: 'inline-block',
      },
    },

    isMinSm: {
      body: {
        textAlign: 'left',
      },
      text: {
        ...headingM(typography),
      },

      message: {
        textAlign: 'left',
      },

      negotiate: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        ...headingS(typography),
      },

      button: {
        marginTop: 0,
        marginLeft: gu2px(3, spacing),
      },

      action: {
        paddingLeft: gu2px(1, spacing),
      },
    },

    isMinMd: {
      text: {
        ...headingL(typography),
        marginBottom: 0,
      },
      body: {
        display: 'flex',
        alignItems: 'center',
        ...cssSides('padding', Side.A, gu2px(4, spacing)),
      },
      message: {
        textAlign: 'right',
      },
      options: {
        flex: 1,
        flexBasis: 'auto',
        marginLeft: gu2px(3, spacing),
      },
    },
  }, [
    { isMinSm },
    { isMinMd },
  ]);
};
